module.exports = __webpack_public_path__ + "img/coach-icon.9b395309.jpg";